import { createContext, useContext, useState, useEffect } from 'react';

// Translation files
const translations = {
  ar: {
    // Common
    common: {
      home: 'الرئيسية',
      dashboard: 'لوحة التحكم',
      login: 'تسجيل الدخول',
      logout: 'تسجيل خروج',
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      add: 'إضافة',
      search: 'بحث',
      filter: 'تصفية',
      all: 'الكل',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات',
      confirm: 'تأكيد',
      back: 'رجوع',
      next: 'التالي',
      previous: 'السابق',
      yes: 'نعم',
      no: 'لا',
      active: 'فعال',
      inactive: 'غير فعال',
      status: 'الحالة',
      date: 'التاريخ',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      password: 'كلمة المرور',
      actions: 'الإجراءات',
      details: 'التفاصيل',
      settings: 'الإعدادات',
      profile: 'الملف الشخصي',
      notifications: 'الإشعارات',
      language: 'اللغة',
      arabic: 'العربية',
      english: 'English',
      copyCode: 'نسخ الكود',
      copied: 'تم النسخ',
    },
    
    // Auth
    auth: {
      loginTitle: 'تسجيل الدخول',
      loginSubtitle: 'مرحباً بك في لوحة تحكم ASB606',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      passwordPlaceholder: 'أدخل كلمة المرور',
      loginButton: 'دخول',
      loggingIn: 'جاري تسجيل الدخول...',
      loginError: 'خطأ في تسجيل الدخول',
      invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
      adminAccess: 'وصول المشرفين فقط',
      secureLogin: 'تسجيل دخول آمن',
    },
    
    // Home Page
    home: {
      heroTitle: 'مجموعة منصات ASB606',
      heroSubtitle: 'نقدم حلولاً متكاملة للأعمال والتجارة الإلكترونية',
      ourPlatforms: 'منصاتنا',
      cloudgmCustomers: 'CloudGM للعملاء',
      cloudgmCustomersDesc: 'منصة تسوق متكاملة للعملاء',
      cloudgmBusiness: 'CloudGM للتجار',
      cloudgmBusinessDesc: 'حلول متكاملة لإدارة متجرك الإلكتروني',
      visitPlatform: 'زيارة المنصة',
      contactUs: 'تواصل معنا',
      aboutUs: 'من نحن',
      services: 'خدماتنا',
      partners: 'شركاؤنا',
      footer: 'جميع الحقوق محفوظة',
    },
    
    // Dashboard
    dashboard: {
      title: 'لوحة التحكم الرئيسية',
      welcome: 'مرحباً',
      admin: 'مشرف',
      quickStats: 'إحصائيات سريعة',
      totalUsers: 'إجمالي المستخدمين',
      totalStores: 'إجمالي المتاجر',
      pendingRequests: 'طلبات معلقة',
      activeAgents: 'الوكلاء النشطين',
      recentActivity: 'النشاط الأخير',
      
      // Control Section
      controlSection: 'قسم التحكم',
      accountManagement: 'إدارة الحساب',
      
      // Performance Section
      performanceSection: 'مؤشر الأداء',
      platformPerformance: 'مؤشر أداء المنصات',
      employeePerformance: 'مؤشر أداء الموظفين',
      visitsAndDownloads: 'مؤشر الزيارات والتحميل',
      
      // Platforms
      platforms: 'المنصات',
      managePlatform: 'إدارة المنصة',
      cloudgmCustomers: 'CloudGM Customers',
      cloudgmBusiness: 'CloudGM Business',
      asb606Company: 'شركة ASB606',
      finance: 'المالية',
      marketing: 'التسويق',
      
      // Stats
      users: 'مستخدم',
      stores: 'متجر',
      merchants: 'تاجر',
      agents: 'وكيل',
    },
    
    // Platform Management
    platform: {
      title: 'إدارة المنصة',
      accounts: 'الحسابات',
      storeRequests: 'طلبات تفعيل المتاجر',
      stores: 'المتاجر',
      subscriptions: 'الاشتراكات',
      agentRequests: 'طلبات عضوية وكيل',
      companyAgents: 'وكلاء الشركة',
      invitationCodes: 'أكواد دعوة الوكلاء',
      
      // Users
      merchant: 'تاجر',
      customer: 'عميل',
      userManagement: 'إدارة المستخدمين',
      addUser: 'إضافة مستخدم',
      editUser: 'تعديل المستخدم',
      deleteUser: 'حذف المستخدم',
      userRole: 'دور المستخدم',
      joinDate: 'تاريخ الانضمام',
      lastLogin: 'آخر دخول',
      
      // Stores
      storeManagement: 'إدارة المتاجر',
      activeStores: 'المتاجر الفعالة',
      rejectedStores: 'المتاجر المرفوضة',
      pendingStores: 'المتاجر المعلقة',
      storeName: 'اسم المتجر',
      storeOwner: 'صاحب المتجر',
      storeType: 'نوع المتجر',
      businessType: 'نوع الشركة',
      activity: 'النشاط',
      
      // Store Actions
      approve: 'موافقة',
      reject: 'رفض',
      requestEdit: 'طلب تعديل',
      rejectReason: 'سبب الرفض',
      confirmApproval: 'تأكيد الموافقة',
      confirmRejection: 'تأكيد الرفض',
      storeApproved: 'تمت الموافقة على المتجر',
      storeRejected: 'تم رفض المتجر',
      
      // Status
      pending: 'قيد المراجعة',
      approved: 'موافق عليه',
      rejected: 'مرفوض',
      needsEdit: 'يحتاج تعديل',
      
      // Agents
      agentId: 'رقم الوكيل',
      requestType: 'نوع الطلب',
      directApplication: 'تقديم مباشر',
      invitation: 'دعوة',
      applicationDate: 'تاريخ التقديم',
      approvedDate: 'تاريخ الموافقة',
      revokeAgent: 'إلغاء الوكالة',
      noAgentRequests: 'لا توجد طلبات عضوية وكيل',
      agentRequestsDesc: 'ستظهر هنا طلبات الوكالة المقدمة من منصة التجار',
      noApprovedAgents: 'لا يوجد وكلاء معتمدين',
      approvedAgentsDesc: 'ستظهر هنا قائمة الوكلاء المعتمدين بعد الموافقة على طلباتهم',
      
      // Invitation Codes
      createCode: 'إنشاء كود جديد',
      codeFormat: 'سيتم إنشاء كود بصيغة INV-XXXXXX',
      maxUses: 'عدد الاستخدامات المسموح',
      expiresInDays: 'صلاحية الكود (أيام)',
      usageCount: 'الاستخدامات',
      expiresAt: 'ينتهي',
      codeCreated: 'تم إنشاء كود الدعوة',
      codeDeleted: 'تم حذف الكود',
      noInvitationCodes: 'لا توجد أكواد دعوة',
      createInvitationDesc: 'أنشئ كود دعوة جديد لدعوة وكلاء جدد',
      expired: 'منتهي',
      exhausted: 'مستنفد',
      disabled: 'معطل',
    },
    
    // Finance
    finance: {
      title: 'الإدارة المالية',
      overview: 'نظرة عامة',
      revenue: 'الإيرادات',
      expenses: 'المصروفات',
      profit: 'الأرباح',
      transactions: 'المعاملات',
      invoices: 'الفواتير',
      reports: 'التقارير',
    },
    
    // Marketing
    marketing: {
      title: 'التسويق',
      campaigns: 'الحملات',
      analytics: 'التحليلات',
      social: 'التواصل الاجتماعي',
      email: 'البريد الإلكتروني',
    },
    
    // Modals
    modals: {
      confirmDelete: 'هل أنت متأكد من الحذف؟',
      confirmAction: 'هل أنت متأكد من هذا الإجراء؟',
      cannotUndo: 'لا يمكن التراجع عن هذا الإجراء',
    },
    
    // Messages
    messages: {
      success: 'تمت العملية بنجاح',
      error: 'حدث خطأ',
      saved: 'تم الحفظ',
      deleted: 'تم الحذف',
      updated: 'تم التحديث',
      created: 'تم الإنشاء',
      copied: 'تم النسخ',
      noRequests: 'لا توجد طلبات',
      allRequestsProcessed: 'جميع الطلبات تمت معالجتها',
    },
  },
  
  en: {
    // Common
    common: {
      home: 'Home',
      dashboard: 'Dashboard',
      login: 'Login',
      logout: 'Logout',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      filter: 'Filter',
      all: 'All',
      loading: 'Loading...',
      noData: 'No data available',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      yes: 'Yes',
      no: 'No',
      active: 'Active',
      inactive: 'Inactive',
      status: 'Status',
      date: 'Date',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      password: 'Password',
      actions: 'Actions',
      details: 'Details',
      settings: 'Settings',
      profile: 'Profile',
      notifications: 'Notifications',
      language: 'Language',
      arabic: 'العربية',
      english: 'English',
      copyCode: 'Copy Code',
      copied: 'Copied',
    },
    
    // Auth
    auth: {
      loginTitle: 'Login',
      loginSubtitle: 'Welcome to ASB606 Control Panel',
      emailPlaceholder: 'Enter your email',
      passwordPlaceholder: 'Enter your password',
      loginButton: 'Login',
      loggingIn: 'Logging in...',
      loginError: 'Login Error',
      invalidCredentials: 'Invalid email or password',
      adminAccess: 'Admin Access Only',
      secureLogin: 'Secure Login',
    },
    
    // Home Page
    home: {
      heroTitle: 'ASB606 Platforms Group',
      heroSubtitle: 'We provide integrated solutions for business and e-commerce',
      ourPlatforms: 'Our Platforms',
      cloudgmCustomers: 'CloudGM Customers',
      cloudgmCustomersDesc: 'Integrated shopping platform for customers',
      cloudgmBusiness: 'CloudGM Business',
      cloudgmBusinessDesc: 'Integrated solutions for managing your online store',
      visitPlatform: 'Visit Platform',
      contactUs: 'Contact Us',
      aboutUs: 'About Us',
      services: 'Our Services',
      partners: 'Our Partners',
      footer: 'All Rights Reserved',
    },
    
    // Dashboard
    dashboard: {
      title: 'Main Dashboard',
      welcome: 'Welcome',
      admin: 'Admin',
      quickStats: 'Quick Stats',
      totalUsers: 'Total Users',
      totalStores: 'Total Stores',
      pendingRequests: 'Pending Requests',
      activeAgents: 'Active Agents',
      recentActivity: 'Recent Activity',
      
      // Control Section
      controlSection: 'Control Section',
      accountManagement: 'Account Management',
      
      // Performance Section
      performanceSection: 'Performance Indicators',
      platformPerformance: 'Platform Performance',
      employeePerformance: 'Employee Performance',
      visitsAndDownloads: 'Visits & Downloads',
      
      // Platforms
      platforms: 'Platforms',
      managePlatform: 'Manage Platform',
      cloudgmCustomers: 'CloudGM Customers',
      cloudgmBusiness: 'CloudGM Business',
      asb606Company: 'ASB606 Company',
      finance: 'Finance',
      marketing: 'Marketing',
      
      // Stats
      users: 'users',
      stores: 'stores',
      merchants: 'merchants',
      agents: 'agents',
    },
    
    // Platform Management
    platform: {
      title: 'Platform Management',
      accounts: 'Accounts',
      storeRequests: 'Store Activation Requests',
      stores: 'Stores',
      subscriptions: 'Subscriptions',
      agentRequests: 'Agent Membership Requests',
      companyAgents: 'Company Agents',
      invitationCodes: 'Agent Invitation Codes',
      
      // Users
      merchant: 'Merchant',
      customer: 'Customer',
      userManagement: 'User Management',
      addUser: 'Add User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userRole: 'User Role',
      joinDate: 'Join Date',
      lastLogin: 'Last Login',
      
      // Stores
      storeManagement: 'Store Management',
      activeStores: 'Active Stores',
      rejectedStores: 'Rejected Stores',
      pendingStores: 'Pending Stores',
      storeName: 'Store Name',
      storeOwner: 'Store Owner',
      storeType: 'Store Type',
      businessType: 'Business Type',
      activity: 'Activity',
      
      // Store Actions
      approve: 'Approve',
      reject: 'Reject',
      requestEdit: 'Request Edit',
      rejectReason: 'Rejection Reason',
      confirmApproval: 'Confirm Approval',
      confirmRejection: 'Confirm Rejection',
      storeApproved: 'Store approved successfully',
      storeRejected: 'Store rejected',
      
      // Status
      pending: 'Pending Review',
      approved: 'Approved',
      rejected: 'Rejected',
      needsEdit: 'Needs Edit',
      
      // Agents
      agentId: 'Agent ID',
      requestType: 'Request Type',
      directApplication: 'Direct Application',
      invitation: 'Invitation',
      applicationDate: 'Application Date',
      approvedDate: 'Approved Date',
      revokeAgent: 'Revoke Agent Status',
      noAgentRequests: 'No agent membership requests',
      agentRequestsDesc: 'Agent requests from the merchant platform will appear here',
      noApprovedAgents: 'No approved agents',
      approvedAgentsDesc: 'Approved agents list will appear here after approval',
      
      // Invitation Codes
      createCode: 'Create New Code',
      codeFormat: 'Code will be created in format INV-XXXXXX',
      maxUses: 'Maximum Uses Allowed',
      expiresInDays: 'Code Validity (days)',
      usageCount: 'Usage',
      expiresAt: 'Expires',
      codeCreated: 'Invitation code created',
      codeDeleted: 'Code deleted',
      noInvitationCodes: 'No invitation codes',
      createInvitationDesc: 'Create a new invitation code to invite new agents',
      expired: 'Expired',
      exhausted: 'Exhausted',
      disabled: 'Disabled',
    },
    
    // Finance
    finance: {
      title: 'Financial Management',
      overview: 'Overview',
      revenue: 'Revenue',
      expenses: 'Expenses',
      profit: 'Profit',
      transactions: 'Transactions',
      invoices: 'Invoices',
      reports: 'Reports',
    },
    
    // Marketing
    marketing: {
      title: 'Marketing',
      campaigns: 'Campaigns',
      analytics: 'Analytics',
      social: 'Social Media',
      email: 'Email Marketing',
    },
    
    // Modals
    modals: {
      confirmDelete: 'Are you sure you want to delete?',
      confirmAction: 'Are you sure about this action?',
      cannotUndo: 'This action cannot be undone',
    },
    
    // Messages
    messages: {
      success: 'Operation successful',
      error: 'An error occurred',
      saved: 'Saved successfully',
      deleted: 'Deleted successfully',
      updated: 'Updated successfully',
      created: 'Created successfully',
      copied: 'Copied to clipboard',
      noRequests: 'No requests',
      allRequestsProcessed: 'All requests have been processed',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'ar';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
